// extracted by mini-css-extract-plugin
module.exports = {"verified":"VerifiedPill_verified__GR9Ff","verifiedText":"VerifiedPill_verifiedText__a8Eui"};